import { render, staticRenderFns } from "./VideoCallMainScreenContainer.vue?vue&type=template&id=6e64a677&scoped=true&"
import script from "./VideoCallMainScreenContainer.vue?vue&type=script&lang=ts&"
export * from "./VideoCallMainScreenContainer.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallMainScreenContainer.vue?vue&type=style&index=0&id=6e64a677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e64a677",
  null
  
)

export default component.exports